import * as React from "react";
import { Outlet } from "react-router-dom";

import { Footer, Header } from "./global";

export const Wrapper = () => {
    return (
        <>
            <Header />
            <div className="app-container">
                <Outlet />
            </div>
            <Footer />
        </>
    );
};
